import api from '../../../config/axios-interceptor';

/**
 * Deleted conversations, for the admin restore view.
 *
 * Uses the ordinary chat search with `deletedOnly=true`. Sent as the string 'true' because the
 * shared param builder drops falsy values, and because only the true case is meaningful — there is
 * deliberately no "show me both", which could otherwise put a deleted conversation back in front of
 * an operator by accident.
 */
export const fetchDeletedChats = async (page = 0, pageSize = 20) => {
    try {
        const params = new URLSearchParams();
        params.append('page', page.toString());
        params.append('size', pageSize.toString());
        params.append('sort', 'updatedAt,desc');
        params.append('deletedOnly', 'true');
        return await api.get(`/api/v1/chat/find-all?${params.toString()}`);
    } catch (error) {
        console.error('❌ Error fetching deleted chats:', error);
        throw error;
    }
};

export const restoreChat = async (id) => {
    try {
        return await api.put(`/api/v1/chat/restore/${id}`);
    } catch (error) {
        console.error('❌ Error restoring chat:', error);
        throw error;
    }
};
